import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrophy: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrophy"><Path d="M12 17.5V15.5" stroke="currentColor"/><Path d="M18.5 4.5H21.5V7.5C21.5 9.15685 20.1569 10.5 18.5 10.5" stroke="currentColor"/><Path d="M5.5 2.5H18.5V9.5C18.5 12.8137 15.8137 15.5 12.5 15.5H11.5C8.18629 15.5 5.5 12.8137 5.5 9.5V2.5Z" stroke="currentColor"/><Path d="M6.5 17.5H17.5V21.5H6.5V17.5Z" stroke="currentColor"/><Path d="M5.5 4.5H2.5V7.5C2.5 9.15685 3.84315 10.5 5.5 10.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconTrophy;
